import React from 'react';
import { useTranslationStatus } from '../hooks/useTranslate';
import { useLanguage } from '../context/LanguageContext';

const TranslateAlert = () => {
  const isTranslating = useTranslationStatus();
  const { currentLanguage } = useLanguage();

  // Ne pas afficher l'alerte si on est en français
  if (currentLanguage === 'fr' || !isTranslating) {
    return null;
  }

  return (
    <div 
      className="fixed top-0 left-0 right-0 w-full bg-blue-50 border-b border-blue-300 text-blue-800 px-6 py-3 flex items-center justify-center gap-3"
      style={{ 
        fontFamily: '"Lora", serif',
        zIndex: 9999 // Au-dessus de TOUT, même du header
      }}
    >
      <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-600 border-t-transparent"></div>
      <div className="text-sm">
        <span className="font-semibold">Traduction en cours...</span>
        <span className="ml-2">Le contenu s'affiche en français pendant la traduction.</span>
      </div>
    </div>
  );
};

export default TranslateAlert;
